import { environmentBase } from './environment.base';
import { Environment } from './environment.model';
import { AuthUtils } from '@libs/core/auth';

export const environment: Environment = {
  ...environmentBase,

  apiUrl: 'https://maurelli-fma-api-testing.zupit.software',
  auth: {
    ...environmentBase.auth,
    ...AuthUtils.buildStandardAzureADB2CEndpoints('maurellifmatesting', 'B2C_1_SignIn'),
    appId: '0e71c5e7-cc62-4f87-9db4-437b7ad23678',
    scope: 'offline_access https://maurellifmatesting.onmicrosoft.com/app-api/access_api',
    logoutUrl: 'https://maurellifmatesting.b2clogin.com/maurellifmatesting.onmicrosoft.com/B2C_1_SignIn/oauth2/v2.0/logout',
    web: {
      redirectUrl: 'https://maurelli-fma-testing.zupit.software',
      windowOptions: 'height=600,left=0,top=0',
    },
    android: {
      redirectUrl: 'msauth://com.maurelligroup.fma/2jmj7l5rSw0yVb%2FvlWAYkK%2FYBwk%3D',
    },
    ios: {
      pkceEnabled: true, // workaround for bug https://github.com/moberwasserlechner/capacitor-oauth2/issues/111
      redirectUrl: 'msauth.com.maurelligroup.fma://auth',
    },
  },

  storage: {
    url: 'https://maurelli-fma-storage-testing.zupit.software',
    assetsFolderName: 'mobile-assets',
    reportTypesFolderName: 'report-types',
    vehicleTypesFolderName: 'vehicle-types',
  },
  appEnvironment: 'testing',
  sentry: {
    enable: true,
    dsn: 'https://6bb7a5f9bfe688b122f94c5f56ee6389@sentry.monitoring.zupit.software/3',
  },
};
